import service from '@/services/SIRcon_aut';

export default {
  namespaced: true,

  state: {
    codeVerify: '',
    hour: null,
    value: {
      picaut_cel: '',
      picaut_mail: '',
      piiaut_num: '',
    },
  },

  mutations: {
    SET_CODE_VERIFY(state, value) {
      state.codeVerify = value.code;
      state.hour = Date.now();
    },

    CLEAR_CODE_VERIFY(state) {
      state.codeVerify = null;
      state.hour = null;
      state.value = {
        picaut_cel: '',
        picaut_mail: '',
        piiaut_num: '',
      };
    },
  },

  actions: {
    /**
     * Envía o reenvía el código de verificación.
     * Si no se pasa `value`, usa el almacenado en el estado.
     */
    send({
      state, commit, dispatch, rootGetters,
    }, value) {
      return new Promise((resolve, reject) => {
        // Si no se pasa `value`, usa lo guardado previamente
        const currentValue = value && Object.keys(value).length
          ? value
          : state.value;

        const payload = {
          dsSIRcon_aut: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRcon_aut: [
              {
                picaut_cel: currentValue?.picaut_cel || '',
                picaut_mail: currentValue?.picaut_mail || '',
                piiaut_num: currentValue?.piiaut_num || '',
                picIp: currentValue.picIp || '',
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRcon_aut;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              // dsSIRcon_aut.eecon_aut[0].aut_cod64
              const code = data?.eecon_aut?.[0]?.aut_cod64 || null;
              // const code = 'MTExMTEx';

              // Guardamos el código y los valores en el estado
              commit('SET_CODE_VERIFY', {
                code,
                value: currentValue,
              });

              resolve(data);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },

  getters: {
    state(state) {
      return {
        ...state,
      };
    },
  },
};
